import _regeneratorRuntime from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { CompactEncrypt } from '../jwe/compact/encrypt.js';
import { encoder } from '../lib/buffer_utils.js';
import { ProduceJWT } from './produce.js';
export var EncryptJWT =
/*#__PURE__*/
function (_ProduceJWT) {
  _inherits(EncryptJWT, _ProduceJWT);

  function EncryptJWT() {
    _classCallCheck(this, EncryptJWT);

    return _possibleConstructorReturn(this, _getPrototypeOf(EncryptJWT).apply(this, arguments));
  }

  _createClass(EncryptJWT, [{
    key: "setProtectedHeader",
    value: function setProtectedHeader(protectedHeader) {
      if (this._protectedHeader) {
        throw new TypeError('setProtectedHeader can only be called once');
      }

      this._protectedHeader = protectedHeader;
      return this;
    }
  }, {
    key: "setKeyManagementParameters",
    value: function setKeyManagementParameters(parameters) {
      if (this._keyManagementParameters) {
        throw new TypeError('setKeyManagementParameters can only be called once');
      }

      this._keyManagementParameters = parameters;
      return this;
    }
  }, {
    key: "setContentEncryptionKey",
    value: function setContentEncryptionKey(cek) {
      if (this._cek) {
        throw new TypeError('setContentEncryptionKey can only be called once');
      }

      this._cek = cek;
      return this;
    }
  }, {
    key: "setInitializationVector",
    value: function setInitializationVector(iv) {
      if (this._iv) {
        throw new TypeError('setInitializationVector can only be called once');
      }

      this._iv = iv;
      return this;
    }
  }, {
    key: "replicateIssuerAsHeader",
    value: function replicateIssuerAsHeader() {
      this._replicateIssuerAsHeader = true;
      return this;
    }
  }, {
    key: "replicateSubjectAsHeader",
    value: function replicateSubjectAsHeader() {
      this._replicateSubjectAsHeader = true;
      return this;
    }
  }, {
    key: "replicateAudienceAsHeader",
    value: function replicateAudienceAsHeader() {
      this._replicateAudienceAsHeader = true;
      return this;
    }
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(key, options) {
        var enc;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                enc = new CompactEncrypt(encoder.encode(JSON.stringify(this._payload)));

                if (this._replicateIssuerAsHeader) {
                  this._protectedHeader = _objectSpread({}, this._protectedHeader, {
                    iss: this._payload.iss
                  });
                }

                if (this._replicateSubjectAsHeader) {
                  this._protectedHeader = _objectSpread({}, this._protectedHeader, {
                    sub: this._payload.sub
                  });
                }

                if (this._replicateAudienceAsHeader) {
                  this._protectedHeader = _objectSpread({}, this._protectedHeader, {
                    aud: this._payload.aud
                  });
                }

                enc.setProtectedHeader(this._protectedHeader);

                if (this._iv) {
                  enc.setInitializationVector(this._iv);
                }

                if (this._cek) {
                  enc.setContentEncryptionKey(this._cek);
                }

                if (this._keyManagementParameters) {
                  enc.setKeyManagementParameters(this._keyManagementParameters);
                }

                return _context.abrupt("return", enc.encrypt(key, options));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function encrypt(_x, _x2) {
        return _encrypt.apply(this, arguments);
      }

      return encrypt;
    }()
  }]);

  return EncryptJWT;
}(ProduceJWT);